import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationPerformanceCenterUpdateAccountNameArgs,
  BackendUserAdAccount,
} from 'src/types/backend';

import { FRAGMENT_AD_ACCOUNT } from './schema';

const MUTATION = gql`
  mutation UpdateAccountName(
    $customerId: ID!
    $accountId: ID!
    $newAccountName: String!
    $dataSource: PerformanceCenterDataSource!
  ) {
    performanceCenterUpdateAccountName(
      customerId: $customerId
      accountId: $accountId
      dataSource: $dataSource
      newAccountName: $newAccountName
    ) {
      ...UserAdAccount
    }
  }
  ${FRAGMENT_AD_ACCOUNT}
`;

type Variables = BackendMutationPerformanceCenterUpdateAccountNameArgs;
type Result = BackendUserAdAccount;

export const updateAccountName = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
